import { Input } from "reactstrap";

import styles from "Pages/Admin/EditMatchTools/Components/EnabledFilter/EnabledFilter.module.css";
import React from "react";

/** This is the default column filter used in React Table. Can be passed a boolean
 * autoFocus to specify that the input should be focused on page load.
 * @param column - The column object for the filter.
 * @param autoFocus - Whether or not to autofocus the input. Default = false.
 * @example
 * In React table column definition in parent of React table:
 * ``` Filter: ({ column }: any) => {
                return <DefaultColumnFilter column={column} autoFocus />;
            },``` 
    OR
    ``` Filter: ({ column }: any) => {
                    return <DefaultColumnFilter column={column} />;
            }```

 */
export default function EnabledFilter({ column }: { column: any }) {
    const { filterValue, setFilter } = column;

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.target.value || undefined;
        setFilter(value);
    }

    return (
        <Input
            type="select"
            className={styles.searchInput}
            value={filterValue || ""}
            // Stop the click to select the search input from bubbling up and triggering a sort
            onClick={(e) => e.stopPropagation()}
            onChange={handleChange}
            placeholder={`Search ...`}
            // Highlight the text input background if column is being filtered
            style={{
                ...(column.filterValue
                    ? {
                          backgroundColor: "var(--dimensionBlueHighlight)",
                          color: "black",
                      }
                    : {}),
            }}
        >
            <option value="">Show all...</option>
            <option value="true">Enabled</option>
            <option value="false">Disabled</option>
        </Input>
    );
}
